<script lang="ts">
	import {
		AdvancedCard,
		ActionsContainer,
		IconButton,
		LabelList,
		DaySchedule,
	} from '@Shelly/shelly-design-system';
	import { startsWeekOnSun } from 'src/helpers/date_helper';
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';

	const dispatch = createEventDispatcher();

	export let title: string = 'UNDEFINED VAL',
		avatar: any = { icon: 'far fa-termometer' },
		subtitle: {} = { value: 'Condition Description', bold: false },
		description: {} = { value: 'Additional info', icon: 'fas fa-clock' },
		labelList = [],
		withLabelList = false,
		withSchedule = false,
		days = [],
		disableDelete = false;

	let isFocusable = false;
	if (startsWeekOnSun()) {
		days.unshift(days.pop());
	}
</script>

{#if withLabelList}
	<AdvancedCard {avatar} {title} {isFocusable} aria-label={title}>
		<LabelList {labelList} slot="main" size="m" />
		<ActionsContainer orientation="vertical" type="simple" slot="right">
			<IconButton
				aria-label={$format('button_edit', { default: 'Edit button' })}
				icon="fas fa-pen"
				slot="first"
				on:click={(e) => {
					e.stopPropagation();
					dispatch('edit');
				}}
			/>
			<IconButton
				aria-label={$format('button_delete', { default: 'Delete button' })}
				icon="fas fa-trash"
				variant="danger"
				slot="second"
				on:click={(e) => {
					e.stopPropagation();
					dispatch('delete');
				}}
			/>
		</ActionsContainer>
	</AdvancedCard>
{:else if withSchedule}
	<AdvancedCard
		{title}
		{avatar}
		{subtitle}
		{description}
		{isFocusable}
		aria-label={title}
		on:click={(e) => dispatch('open_detailed')}
	>
		<DaySchedule {days} slot="title" />

		<ActionsContainer orientation="vertical" type="simple" slot="right">
			<IconButton
				aria-label={$format('button_edit', { default: 'Edit button' })}
				icon="fas fa-pen"
				slot="first"
				on:click={() => dispatch('edit')}
			/>
			<!-- {#if withDeleteBtn} -->
			<IconButton
				aria-label={$format('button_delete', { default: 'Delete button' })}
				icon="fas fa-trash"
				variant="danger"
				slot="second"
				disabled={disableDelete}
				on:click={(e) => {
					e.stopPropagation();
					dispatch('delete');
				}}
			/>
			<!-- {/if} -->
		</ActionsContainer>
	</AdvancedCard>
{:else}
	<AdvancedCard
		{avatar}
		{title}
		{subtitle}
		{description}
		{isFocusable}
		aria-label={title}
		on:click={(e) => dispatch('open_detailed')}
	>
		<ActionsContainer orientation="vertical" type="simple" slot="right">
			<IconButton
				aria-label={$format('button_edit', { default: 'Edit button' })}
				icon="fas fa-pen"
				slot="first"
				on:click={() => dispatch('edit')}
			/>
			<IconButton
				aria-label={$format('button_delete', { default: 'Delete button' })}
				icon="fas fa-trash"
				variant="danger"
				slot="second"
				on:click={() => dispatch('delete')}
			/>
		</ActionsContainer>
	</AdvancedCard>
{/if}
